/* Φ4 Σ07-11 (owner) — απαλό marquee για policies-strip + brands-row. v2.
 * Αρχές: (α) κίνηση μέσω scrollLeft σε native overflow container → το
 * χειροκίνητο scroll (δάχτυλο/ροδέλα/drag) δουλεύει ΚΑΙ γρήγορα, φυσικά·
 * (β) αντίγραφα περιεχομένου ΔΥΝΑΜΙΚΑ μέχρι το μήκος να φτάνει για
 * αδιάλειπτο βρόχο ΣΕ ΚΑΘΕ πλάτος (v2 owner-report: με 1 αντίγραφο η
 * 4-στοιχείων μπάρα τέλειωνε σε φαρδιές οθόνες και «σταματούσε»)·
 * (γ) παύση ΜΟΝΟ σε πραγματική οριζόντια αλληλεπίδραση με τη μπάρα —
 * wheel/drag/οριζόντιο σύρσιμο — ΟΧΙ σε άγγιγμα-πέρασμα κατά το κάθετο
 * page-scroll (v2 owner-report: στο κινητό «κολλούσε» γιατί το δάχτυλο
 * περνούσε από πάνω της)· (δ) prefers-reduced-motion → καμία αυτόματη
 * κίνηση· (ε) τρέχει μόνο όταν ορατό (IntersectionObserver)· (στ) κίνηση
 * χωρίς layout αλλαγές (CLS gate).
 * Χρήση: <div data-marquee="left|right" data-marquee-speed="0.44">
 *          <div data-marquee-track> …items… </div></div>
 */
(function () {
  if (window.__tjMarquee) return;
  window.__tjMarquee = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(el) {
    var track = el.querySelector('[data-marquee-track]');
    if (!track || track.children.length === 0) return;

    var originals = Array.prototype.slice.call(track.children);

    function cloneSet() {
      originals.forEach(function (child) {
        var c = child.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('tabindex', '-1');
        c.querySelectorAll && c.querySelectorAll('a, button, input').forEach(function (f) { f.setAttribute('tabindex', '-1'); });
        track.appendChild(c);
      });
    }

    var copies = 1;
    var oWidth = 0; // πλάτος ΕΝΟΣ αντιτύπου (το «βήμα» του βρόχου)

    // αντίγραφα μέχρι: συνολικό ≥ 1 αντίτυπο + 2 viewport (ο βρόχος [0,oWidth)
    // έχει πάντα γεμάτο κάδρο και προς τις δύο φορές)· cap 8 για ασφάλεια
    function ensureLength() {
      oWidth = track.scrollWidth / copies;
      if (oWidth <= 0) return;
      while (copies < 8 && track.scrollWidth < oWidth + 2 * el.clientWidth) {
        cloneSet();
        copies++;
      }
      oWidth = track.scrollWidth / copies;
    }
    ensureLength();

    var dir = el.getAttribute('data-marquee') === 'right' ? -1 : 1;
    var speed = parseFloat(el.getAttribute('data-marquee-speed')) || 0.44;
    var paused = false;
    var pauseTimer = null;
    var visible = false;
    var rafId = null;
    var acc = 0;
    var expected = null; // πού αφήσαμε ΕΜΕΙΣ το scrollLeft (διάκριση από χρήστη)

    function normalize() {
      if (oWidth <= 0) return;
      if (el.scrollLeft >= oWidth) el.scrollLeft -= oWidth;
      else if (el.scrollLeft <= 0) el.scrollLeft += oWidth;
    }

    function step() {
      rafId = null;
      if (!visible) return;
      if (!paused && !reduced) {
        // sub-pixel συσσώρευση (το scrollLeft στρογγυλεύει — χωρίς acc θα κολλούσε)
        acc += speed * dir;
        var whole = acc > 0 ? Math.floor(acc) : Math.ceil(acc);
        if (whole !== 0) {
          el.scrollLeft += whole;
          normalize();
          acc -= whole;
          expected = el.scrollLeft;
        }
      }
      rafId = requestAnimationFrame(step);
    }
    function start() { if (!rafId) rafId = requestAnimationFrame(step); }

    function userPause() {
      paused = true;
      clearTimeout(pauseTimer);
      pauseTimer = setTimeout(function () {
        paused = false;
        expected = el.scrollLeft;
      }, 2500);
    }

    // παύση: ροδέλα + mouse-drag ρητά· η αφή ΜΟΝΟ αν όντως κύλησε τη μπάρα
    // οριζόντια (ο έλεγχος γίνεται στο scroll-event: θέση ≠ αναμενόμενης)
    el.addEventListener('wheel', userPause, { passive: true });
    el.addEventListener('scroll', function () {
      if (expected === null) return;
      if (Math.abs(el.scrollLeft - expected) > 3) userPause(); // χρήστης, όχι εμείς
    }, { passive: true });

    // desktop: drag-to-scroll με το ποντίκι (grab)
    var dragging = false, dragStartX = 0, dragStartScroll = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      dragging = true;
      dragStartX = e.clientX;
      dragStartScroll = el.scrollLeft;
      el.classList.add('is-dragging');
      userPause();
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      userPause();
      el.scrollLeft = dragStartScroll - (e.clientX - dragStartX);
      normalize();
      expected = el.scrollLeft;
    });
    window.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      el.classList.remove('is-dragging');
      // drag >6px = scroll-πρόθεση ΟΧΙ click → κατάπιε το επερχόμενο click
      if (Math.abs(e.clientX - dragStartX) > 6) {
        var swallow = function (ce) { ce.preventDefault(); ce.stopPropagation(); };
        el.addEventListener('click', swallow, { capture: true, once: true });
        setTimeout(function () { el.removeEventListener('click', swallow, { capture: true }); }, 80);
      }
    });

    // δεξιόστροφο: ξεκίνα από «ένα αντίτυπο μέσα» ώστε να υπάρχει περιεχόμενο πίσω
    if (dir === -1) { el.scrollLeft = oWidth; }
    expected = el.scrollLeft;

    // rotation/resize + φόρτωση γραμματοσειρών: ξανα-υπολόγισε μήκη/αντίγραφα
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { ensureLength(); normalize(); expected = el.scrollLeft; }, 200);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ensureLength(); expected = el.scrollLeft; });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) { expected = el.scrollLeft; start(); }
      }, { threshold: 0.05 }).observe(el);
    } else {
      visible = true;
      start();
    }
  }

  function boot() { document.querySelectorAll('[data-marquee]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
